/*
Replace
resourceName with your resource Name :) Take care about different writings!
/!\ ResourceName resourceName ResourceNames resourceNames /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";

export const formLocaleSlice = createSlice({
  name: "formLocales",
  initialState: {
    projectAvailableLocales: {},
    defaultAvailableLocales: ["en", "de"],
    allAvailableLocales: ["en", "de", "it", "es", "fr", "pt"],
    selectedLocale: "en",
    localesNames: {
      en: "English",
      de: "Deutsch",
      it: "Italiano",
      es: "Español",
      fr: "Français",
      pt: "Português",
    },
    localesFlags: {
      en: "🇬🇧",
      de: "🇩🇪",
      it: "🇮🇹",
      es: "🇪🇸",
      fr: "🇫🇷",
      pt: "🇵🇹",
    }
  },
  reducers: {
    setDefaultAvailableLocales: (state, action) => {
      state.defaultAvailableLocales = action.payload;
    },
    setSelectedLocale: (state, action) => {
      state.selectedLocale = action.payload;
    },
    setProjectAvailableLocales: (state, action) => {
      state.projectAvailableLocales[action.payload.projectId] =
        action.payload.availableLocales;
    },
  },
});
export const { setDefaultAvailableLocales, setSelectedLocale } =
  formLocaleSlice.actions;

export const actions = formLocaleSlice.actions;

export const getProjectAvailableLocales = createSelector(
  (state) => state.formLocales.projectAvailableLocales,
  (state) => state.formLocales.defaultAvailableLocales,
  (_, id) => id,
  (projectAvailableLocales, defaultAvailableLocales, id) => {
    return (id && projectAvailableLocales && projectAvailableLocales[id]) || defaultAvailableLocales;
  }
);


export default formLocaleSlice.reducer;
